import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColumnWideRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"column-wide-remove"} maskId="square-filled-radius-0-stroke-1-IconColumnWideRemove"><path d="M2 4V20H12.5V5L21 5V12H22V4L2 4Z" fill="currentColor"/><path d="M16.5 13.7929L15.7929 14.5L18.2929 17L15.7929 19.5L16.5 20.2071L19 17.7071L21.5 20.2071L22.2071 19.5L19.7071 17L22.2071 14.5L21.5 13.7929L19 16.2929L16.5 13.7929Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconColumnWideRemove;
